/** biome-ignore-all lint/style/noMagicNumbers: TODO: fix */
import { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Form } from 'antd';
import { addDays, format, isAfter, isEqual, isValid, parse, startOfDay } from 'date-fns';

import { getLocalDateTime } from '@/utils/date';
import { calculateLinearFeet } from '@/views/screens/Savers/utils';

import { setAppLoader } from '../../../../redux/common/CommonActions';
import {
  getAllFreightCommodityIdEffect,
  getBranchesByCustomerEffect,
  getTrailerConditionStatusEffect,
  getTrailerDetailsEffect,
  getTrailerRequestStatusEffect,
  getTrailersListEffect,
  getUnitSizesEffect,
  getUserRelationEffect,
  saveTrailerRequest,
} from '../../../../redux/Savers/SaversEffects';
import { getFormattedTimeString } from '../../../../utilz';
import { DEFAULT_PAGE_NUMBER, excludedStatuses, SUPPLIER_REGION_KEYS } from '../trailer-request.constants';
import CtTrailerRequest from './CtTrailerRequest';
import StoreTrailerRequest from './StoreTrailerRequest';
import SupplierTrailerRequest from './SupplierTrailerRequest';

const deliveryTimeOptions = [
  {
    label: '8 AM to 12 PM',
    value: '8 AM to 12 PM',
  },
  {
    label: '12 PM to 4 PM',
    value: '12 PM to 4 PM',
  },
];
const DEFAULT_PAGE_SIZE = 500;

export default function TrailerRequest() {
  const dispatch = useDispatch();

  const [formAddTrailerRequest] = Form.useForm();

  const currentDate = getLocalDateTime();
  const [nameLabel, setNameLabel] = useState('Team Member Name');
  const [locationLabel, setLocationLabel] = useState('Team Member Location ID');
  const [addressLabel, setAddressLabel] = useState('Team Member Address');
  const [phoneLabel, setPhoneLabel] = useState('Team Member Phone #');
  const [trlHidden, setTrlHidden] = useState(false);
  const [pickupDateLabel, setPickupDateLabel] = useState('Pickup Date');
  const [pickupTimeLabel, setPickupTimeLabel] = useState('Pickup Time');
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedTrailerPickValue, setSelectedTrailerPickValue] = useState('');
  const [selectedTrailerDoorValue, setSelectedTrailerDoorValue] = useState('');
  const [selectedLoadValue, setSelectedLoadValue] = useState('');
  const [partnerLocationOptions, setPartnerLocationOptions] = useState([]);
  const [trailerOptions, setTrailerOptions] = useState([]);
  const [trailerSizeOptions, setTrailerSizeOptions] = useState([]);
  const [commodityOptions, setCommodityOptions] = useState([]);
  const [relationOptions, setRelationOptions] = useState([]);
  const [requestTypeOptions] = useState([
    { label: 'Inbound', value: 'I' },
    { label: 'Outbound', value: 'O' },
    { label: 'Round', value: 'R' },
  ]);
  const [liveLoadHoursOptions] = useState([
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
  ]);
  const [liveLoadHours, setLiveLoadHours] = useState(0);
  const [trailerConditionStatusOptions, setTrailerConditionStatusOptions] = useState([]);
  const [hidden, setHidden] = useState(false);
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [trailerID, setTrailerID] = useState(0);
  const [trailerName, setTrailerName] = useState('');
  const [locationID, setLocationID] = useState(0);
  const [stop1, setStop1] = useState(0);
  const [stop2, setStop2] = useState(0);
  const [stop3, setStop3] = useState(0);
  const [pickupTrailerSize, setPickupTrailerSize] = useState('');
  const [trailerConditionStatusID, setTrailerConditionStatusID] = useState('');
  const [trailerRequestDate, setTrailerRequestDate] = useState(currentDate);
  const [trailerRequestTimeframe, setTrailerRequestTimeframe] = useState('');
  const [isLoadedPickUp, setIsLoadedPickUp] = useState(false);
  const [isEmptyPickUp, setIsEmptyPickUp] = useState(false);
  const [productType, setProductType] = useState('');
  const [productTypeName, setProductTypeName] = useState('');
  const [productName, setProductName] = useState('');
  const [sealNumber, setSealNumber] = useState(null);
  const [estimatedWeight, setEstimatedWeight] = useState(0);
  const [estimatedDimension, setEstimatedDimension] = useState(0);
  const [deliveryproductType, setdeliveryProductType] = useState('');
  const [deliveryproductTypeName, setdeliveryProductTypeName] = useState('');
  const [deliveryDate, setDeliveryDate] = useState(null);
  const [deliveryTime, setDeliveryTime] = useState('');
  const [pTimeToCheck, setPTimeToCheck] = useState('');
  const [isEmptyDelivered, setIsEmptyDelivered] = useState(false);
  const [isLoadedDelivered, setIsLoadedDelivered] = useState(false);
  const [isMultiStop, setIsMultiStop] = useState(false);
  const [trailerDoorType, setTrailerDoorType] = useState('');
  const [isLiveLoad, setIsLiveLoad] = useState(false);
  const [specialInstruction, setSpecialInstruction] = useState('');
  const [userType, setUserType] = useState('');
  const [fullName, setFullName] = useState('');
  const [branchDesc, setBranchDesc] = useState('');
  const [branchKey, setBranchKey] = useState(0);
  const [branchAddr1, setBranchAddr1] = useState('');
  const [branchBusPhone, setBranchBusPhone] = useState('');
  const [rscm, setRSCM] = useState('');
  const [scs, setSCS] = useState('');
  const [requester, setRequester] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [branchAddr2, setBranchAddr2] = useState('');
  const [branchCity, setBranchCity] = useState('');
  const [branchState, setBranchState] = useState('');
  const [branchPostal, setBranchPostal] = useState('');
  const [branchCustRef, setBranchCustRef] = useState('');
  const [newErrorAlert, setNewErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [loadTrailer, setLoadTrailer] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [warning, setWarning] = useState('');
  const [districtManager, setDistrictManager] = useState('');
  const [addressBookModal, setAddressBookModal] = useState(false);
  const [matchesDDP, setMatchesDDP] = useState(true);
  const [expDeliveryDate, setExpDeliveryDate] = useState(null);
  const [expDeliveryTime, setExpDeliveryTime] = useState(null);
  const [comments, setComments] = useState('');
  const [branchContact, setBranchContact] = useState(null);
  const [percentage, setPercentage] = useState(0);
  const [showProductsModal, setShowProductsModal] = useState(false);
  const [tableData, setTableData] = useState([
    {
      estDimension: '',
      estWeight: '',
      key: 1,
      productType,
      productTypeLabel: productTypeName || '',
    },
  ]);

  const onConfirmFunc = () => {
    setNewErrorAlert(false);
    setErrorMessage('');
  };

  const companyId = useSelector((state) => state.auth.selectedCompany.companyId, shallowEqual);

  // biome-ignore lint/correctness/useExhaustiveDependencies:TODO:add dependencies
  useEffect(() => {
    if (companyId) {
      getPartnerLocations(companyId);
      getUserRelations();
      getTrailerSizes();
      getTrailerCommodities();
      getTrailerConditionStatus();
      getTrailerRequestStatus();
    }
  }, [companyId]);

  // biome-ignore lint/correctness/useExhaustiveDependencies:TODO:add dependencies
  useEffect(() => {
    if (relationOptions && relationOptions.length > 0) {
      dispatch(setAppLoader(true));
      if (
        relationOptions[0].userType !== 'CT' &&
        relationOptions[0].userType !== 'Store' &&
        relationOptions[0].userType !== 'STORE'
      ) {
        setNameLabel('Supplier Name');
        setLocationLabel('Supplier Location ID');
        setAddressLabel('Supplier Address');
        setPhoneLabel('Supplier Phone #');
        setTrlHidden(true);
      }
      setLocationID(relationOptions[0].branchKey);
      setBranchDesc(relationOptions[0].branchDesc);
      setBranchAddr1(relationOptions[0].branchAddr1);
      setBranchBusPhone(relationOptions[0].branchBusPhone);
      setRSCM(relationOptions[0].rscm);
      setSCS(relationOptions[0].scs);
      setBranchAddr2(relationOptions[0].branchAddr2);
      setBranchCity(relationOptions[0].branchCity);
      setBranchState(relationOptions[0].stateName);
      setBranchPostal(relationOptions[0].branchZip);
      setBranchCustRef(relationOptions[0].branchCustRef);
      setBranchKey(relationOptions[0]?.branchKey);
      setBranchContact(relationOptions[0]?.branchContact);
      formAddTrailerRequest.setFieldsValue({
        districtManager: relationOptions[0]?.districtManager,
        PartnerLocation: relationOptions[0]?.branchDesc,
        txtaddr1: `${relationOptions[0]?.branchAddr1}, ${relationOptions[0]?.branchCity}, ${relationOptions[0]?.stateName} ${relationOptions[0]?.branchZip}`,
        txtDelAddr: relationOptions[0]?.branchAddr1,
        txtDelLocation: relationOptions[0]?.branchKey,
        txtphone: relationOptions[0]?.branchBusPhone,
        txtRequester: relationOptions[0]?.fullName,
        txtrscm: relationOptions[0]?.rscm,
        txtscs: relationOptions[0]?.scs,
      });
      if (userType !== 'Store') {
        formAddTrailerRequest.setFieldsValue({
          txtfullname: relationOptions[0]?.branchCustRef,
        });
        setFullName(relationOptions[0].fullName);
      }
      if (userType === 'Supplier') {
        formAddTrailerRequest.setFieldsValue({
          PartnerLocation: relationOptions[0]?.branchCustRef,
          txtfullname: relationOptions[0]?.branchDesc,
        });
        setFullName(relationOptions[0].branchDesc);
      }
      if (relationOptions[0].userType === 'Supplier') {
        formAddTrailerRequest.setFieldsValue({
          deliveryLocation: relationOptions[0]?.branchCustRef,
          pickupLocation: relationOptions[0]?.branchCustRef,
          txtAddr2: relationOptions[0]?.branchAddr2,
          txtCity: relationOptions[0]?.branchCity,
          txtPostal: relationOptions[0]?.branchZip,
          txtState: relationOptions[0]?.stateName,
        });
      }
      if (relationOptions.userType !== 'Supplier') {
        formAddTrailerRequest.setFieldsValue({
          deliveryLocation: `${relationOptions[0]?.branchDesc} - ${relationOptions[0]?.branchCustRef}`,
          pickupLocation: `${relationOptions[0]?.branchDesc} - ${relationOptions[0]?.branchCustRef}`,
        });
      }
      dispatch(setAppLoader(false));
    }
  }, [relationOptions]);

  // biome-ignore lint/correctness/useExhaustiveDependencies:TODO:add dependencies
  useEffect(() => {
    if (userType === 'Supplier') {
      setChecked(!checked);
      setIsEmptyPickUp(false);
      setIsLoadedPickUp(true);
      setSelectedTrailerPickValue('Loaded');
      setPickupDateLabel('Date Trailer Loaded');
      setPickupTimeLabel('Time Trailer Loaded');
      getTrailerList(branchKey, 'LOD');
    }
  }, [userType]);

  const getPartnerLocations = async (companyId) => {
    dispatch(setAppLoader(true));
    if (companyId) {
      try {
        // TODO: useGetShipmentVendorBranch hook
        const { data } = await getBranchesByCustomerEffect(companyId);
        const options = data.map((row) => ({
          branchContact: row.branchContact,
          label: SUPPLIER_REGION_KEYS.includes(row.regionKey)
            ? row.branchCustRef
            : `${row.branchDesc} - ${row.branchCustRef}`,
          value: row.branchKey,
        }));
        setPartnerLocationOptions(options);
      } catch (error) {
        console.error(error);
        setPartnerLocationOptions([]);
      }
    }
  };
  const saveTrailerRequestData = async () => {
    const requestData = [];
    try {
      dispatch(setAppLoader(true));

      const isMixedProduct = productType === 5 && branchContact === 'Y';
      const products = tableData.map((item) => ({
        estimatedDimension: Number(item.estDimension) || 0,
        estimatedWeight: Number(item.estWeight) || 0,
        productType: item.productType?.toString() || '',
      }));
      requestData.push({
        commodity: productName,
        deliveryDate,
        deliveryProductType: deliveryproductType.toString(),
        deliveryTimeFrame: deliveryTime,
        estimatedDimension: products[0]?.estimatedDimension,
        estimatedWeight: products[0]?.estimatedWeight,
        expDeliveryDate,
        expDeliveryTime,
        isEmptyDelivered,
        isEmptyPickUp,
        isLiveLoad,
        isLoadedDelivered,
        isLoadedPickUp,
        isMixedProduct,
        isMultiStop,
        liveLoadHours,
        locationID,
        matchesDDP,
        pickupTrailerSize: pickupTrailerSize.toString(),
        products,
        productType: productType.toString(),
        requesterName: fullName,
        requesterPhone: phoneNumber,
        requesttimeframe: trailerRequestTimeframe,
        sealNumber,
        specialInstruction,
        specialInstructionTrailerSize: '',
        stopOne: stop1,
        stopThree: stop3,
        stopTwo: stop2,
        supplierNumber: userType === 'Supplier' ? branchCustRef : '',
        trafficCoordinatorID: 0,
        trailerConditionStatusID,
        trailerDoorType,
        trailerID,
        trailerRequestDate,
        trailerRequestID: 0,
        trailerRequestStautsID: '',
      });

      const { data } = await saveTrailerRequest(requestData[0]);
      if (data === 1) {
        setHidden(false);
        setAlertMessage('Trailer request data saved.');
        setAlertOpen(true);
        formAddTrailerRequest.resetFields();

        window.location.href = '/savers';
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setAppLoader(false));
    }
  };

  const handleAlertOk = () => {
    setAlertOpen(false);
    window.location.href = '/savers';
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const getTrailerList = async (branchKey) => {
    try {
      setLoadTrailer(true);
      const params = {};
      if (branchKey && branchKey !== '0') {
        params.branchKey = branchKey;
      }
      if (userType === 'Store' || (userType === 'CT' && branchContact === 'Y')) {
        params.trailerMovementType = 'Outbound';
      }
      const { data } = await getTrailersListEffect({
        PageNumber: DEFAULT_PAGE_NUMBER,
        PageSize: DEFAULT_PAGE_SIZE,
        ...params,
      });

      const options = data
        .filter((row) => {
          const isExcluded = excludedStatuses.includes(row.trailerStatusID);
          const isPlanned = row.trailerStatusID === 'PLN';
          return userType === 'Supplier' ? !isExcluded && !isPlanned : !isExcluded;
        })
        .map((row) => ({
          label: row.trailerNumber,
          value: row.trailerID,
        }));
      setTrailerOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerOptions([]);
    } finally {
      setLoadTrailer(false);
    }
  };

  const getTrailerSizes = async () => {
    try {
      const { data } = await getUnitSizesEffect();

      const options = data.map((row) => ({
        label: row.size,
        value: row.id,
      }));
      setTrailerSizeOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerSizeOptions([]);
    }
  };

  const getUserRelations = async () => {
    dispatch(setAppLoader(true));
    try {
      const { data } = await getUserRelationEffect();

      setRelationOptions(data);
      if (data.length > 0) {
        setUserType(data[0].userType);
        setBranchKey(data[0].branchKey);
        setDistrictManager(data[0].districtManager);
      } else {
        getTrailerList();
        setUserType('');
        setFullName('');
        setLocationID(0);
        setBranchDesc('');
        setBranchAddr1('');
        setBranchBusPhone('');
        setRSCM('');
        setSCS('');
        setNameLabel('Supplier Name');
        setLocationLabel('Supplier Location ID');
        setAddressLabel('Supplier Address');
        setPhoneLabel('Supplier Phone #');
        setTrlHidden(true);
      }
    } catch (error) {
      console.error(error);
      setUserType('');
      setFullName('');
      setBranchKey(0);
      setLocationID(0);
      setBranchDesc('');
      setBranchAddr1('');
      setBranchBusPhone('');
      setRSCM('');
      setSCS('');
    }
  };

  const getTrailerCommodities = async () => {
    try {
      const { data } = await getAllFreightCommodityIdEffect();

      const options = data.map((row) => ({
        label: row.freightCommodity,
        value: row.freightCommodityID,
      }));
      setCommodityOptions(options);
    } catch (error) {
      console.error(error);
      setCommodityOptions([]);
    }
  };

  const getTrailerConditionStatus = async () => {
    try {
      const { data } = await getTrailerConditionStatusEffect();

      const options = data.map((row) => ({
        label: row.codeDesc,
        value: row.codeId,
      }));
      setTrailerConditionStatusOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerConditionStatusOptions([]);
    }
  };

  const getTrailerRequestStatus = async () => {
    try {
      await getTrailerRequestStatusEffect();
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setAppLoader(false));
    }
  };

  const getTrailerDetailsData = async (trailerID) => {
    try {
      const { data } = await getTrailerDetailsEffect(trailerID);
      if (data.length > 0) {
        setTrailerConditionStatusID(data[0].trailerStatusID);
        setPickupTrailerSize(data[0].unitSizeID);
        formAddTrailerRequest.setFieldsValue({
          ConditionStatus: data[0].trailerStatusID,
        });
        formAddTrailerRequest.setFieldsValue({
          trailerSize: data[0].unitSizeID,
        });
      }
    } catch (error) {
      console.error(error);
      setTrailerConditionStatusID('');
      setPickupTrailerSize('');
    }
  };

  const selectStop1 = (e) => {
    setStop1(e.value);
  };

  const selectStop2 = (e) => {
    setStop2(e.value);
  };

  const selectStop3 = (e) => {
    setStop3(e.value);
  };

  const selectLocationID = (e) => {
    setLocationID(e.value);
    setBranchKey(e.value);
    setBranchDesc(e.label);
    setBranchContact(e.branchContact);
    formAddTrailerRequest.setFieldsValue({
      deliveryLocation: e.value,
      pickupLocation: e.value,
    });
  };

  const selectTrailerConditionStatus = (e) => {
    setTrailerConditionStatusID(e.value);
  };

  const selectTrailerName = (e) => {
    if (!e || !e.value || e.value === 0 || e.value === '0') {
      setTrailerID(0);
      setTrailerName('');
      setPickupTrailerSize('');
      setTrailerConditionStatusID('');
      formAddTrailerRequest.setFieldsValue({
        ConditionStatus: null,
        trailerName: null,
        trailerSize: null,
      });
    } else {
      setTrailerID(e.value);
      setTrailerName(e.label);
      getTrailerDetailsData(e.value);
    }
  };

  const selectTrailerSize = (e) => {
    setPickupTrailerSize(e.value);
  };

  const selectRequestDate = (e) => {
    let trailerreqdate = format(new Date(e), 'yyyy-MM-dd');
    if (pTimeToCheck) {
      const newDate = `${trailerreqdate} ${pTimeToCheck}`;
      const date = new Date(newDate);
      trailerreqdate = getFormattedTimeString(date);
    }
    validatePickupDate(trailerreqdate);
    setTrailerRequestDate(trailerreqdate);
  };

  const selectRequestTimeframe = (e) => {
    setTrailerRequestTimeframe(e.value);
  };

  const selectRequestTime = (e) => {
    const trailerreqtime = format(new Date(e), 'HH:mm:ss');
    setPTimeToCheck(format(new Date(e), 'HH:mm'));
    const newDate = `${trailerRequestDate.substring(0, 10)} ${trailerreqtime}`;
    const date = new Date(newDate);
    const formattedDate = getFormattedTimeString(date);
    setTrailerRequestDate(formattedDate);
  };

  const setRequesterName = (e) => {
    setRequester(e.currentTarget.value);
  };

  const setSupplierPhone = (e) => {
    setPhoneNumber(e.currentTarget.value);
  };
  const selectCommodity = (e) => {
    if (e) {
      setProductType(e.value);
      setProductTypeName(e.label);
      setEstimatedDimension(calculateLinearFeet(estimatedWeight, e.value));
      if (Number(e.value) !== 5) {
        setTableData([
          {
            estDimension: '',
            estWeight: '',
            key: 1,
            productType: e.value,
          },
        ]);
      }
    } else {
      setProductType('');
      setProductTypeName('');
      setEstimatedDimension(0);
    }
  };

  const selectProduct = (e) => {
    setProductName(e.currentTarget.value);
  };
  const selectSealNumber = (e) => {
    setSealNumber(e.currentTarget.value);
  };

  const setLiveLoadUnloadHour = (e) => {
    if (e) {
      setLiveLoadHours(e.value);
    } else {
      setLiveLoadHours(0);
    }
  };

  const selectdeliveryCommodity = (e) => {
    if (e) {
      setdeliveryProductType(e.value);
      setdeliveryProductTypeName(e.label);
    } else {
      setdeliveryProductType('');
      setdeliveryProductTypeName('');
    }
  };

  const selectDeliveryDate = (e) => {
    const trailerdeldate = format(new Date(e), 'yyyy-MM-dd');
    validateDeliverydate(trailerdeldate);
    setDeliveryDate(trailerdeldate);
  };

  const selectDeliveryTime = (e) => {
    setDeliveryTime(e.value);
  };

  const selectDelivered = (e) => {
    if (e.currentTarget.id === 'Empty') {
      setIsEmptyDelivered(true);
      setIsLoadedDelivered(false);
      setSelectedValue('Empty');
    } else if (e.currentTarget.id === 'Loaded') {
      setIsEmptyDelivered(false);
      setIsLoadedDelivered(true);
      setSelectedValue('Loaded');
    } else if (e.currentTarget.id === 'None') {
      setIsEmptyDelivered(false);
      setIsLoadedDelivered(false);
      setSelectedValue('None');
    }
    formAddTrailerRequest.resetFields(['deliveryDate', 'selectDeliveryTime', 'Commodity1']);
    setDeliveryDate(null);
    setDeliveryTime('');
    setdeliveryProductType('');
    setdeliveryProductTypeName('');
  };

  const closeModal = () => {
    setHidden(!hidden);
  };

  const validateEstWeight = () => {
    if (selectedTrailerPickValue === 'Loaded' && userType !== 'Supplier') {
      const hasInvalidWeight = tableData.some((item) => Number(item.estWeight) <= 0);

      if (hasInvalidWeight) {
        setNewErrorAlert(true);
        setErrorMessage(
          tableData.length > 1 ? 'Estimated weight is required for all products' : 'Estimated weight is required',
        );
        return false;
      }
    }
    return true;
  };

  const validateRequesterName = () => {
    if (!fullName && userType === 'Store') {
      setNewErrorAlert(true);
      setErrorMessage('Please enter a Team Member Name');
      return false;
    }
    return true;
  };

  const openRequestPopup = () => {
    if (
      validateLoaded() === true &&
      validateTrailer() === true &&
      requiredPickUpdate() === true &&
      validateCommodity() === true &&
      validateDeliveryTimeRange() &&
      validateDelCommodity() === true &&
      validateStop() === true &&
      validateSpecialInstruction() === true &&
      validateEstWeight() === true &&
      validatePickupTimeframe() === true &&
      validateRequesterName() === true
    ) {
      setHidden(true);
    }
  };

  const shouldToggleChecked = (e) => {
    dispatch(setAppLoader(true));
    setChecked(!checked);
    if (e.currentTarget.id === 'pickEmpty') {
      setIsEmptyPickUp(true);
      setIsLoadedPickUp(false);
      setSelectedTrailerPickValue('Empty');
      setPickupDateLabel('Date Trailer Emptied');
      setPickupTimeLabel('Time Trailer Emptied');
      getTrailerList(branchKey, 'EMT');
    } else if (e.currentTarget.id === 'pickLoaded') {
      setIsEmptyPickUp(false);
      setIsLoadedPickUp(true);
      setEstimatedDimension(0);
      setSelectedTrailerPickValue('Loaded');
      setPickupDateLabel('Date Trailer Loaded');
      setPickupTimeLabel('Time Trailer Loaded');
      getTrailerList(branchKey, 'LOD');
    } else if (e.currentTarget.id === 'pickNone') {
      setIsEmptyPickUp(false);
      setIsLoadedPickUp(false);
      setSelectedTrailerPickValue('None');
      setPickupDateLabel('Pickup Date');
      setPickupTimeLabel('Pickup Time');
      setTrailerOptions([]);
    }

    dispatch(setAppLoader(false));
    formAddTrailerRequest.resetFields(['trailerName', 'trailerSize', 'trailerDate', 'selectPickupTime', 'Commodity']);
    setTrailerID(0);
    setTrailerName('');
    setPickupTrailerSize('');
    setTrailerRequestDate(currentDate);
    setBranchDesc('');
    setProductType('');
    setProductTypeName('');
    setEstimatedDimension(0);
    setEstimatedWeight(0);
  };

  const handleChangeMultiStopY = (e) => {
    setChecked1(!checked1);
    if (e.currentTarget.checked) {
      setIsMultiStop(true);
    } else {
      setIsMultiStop(false);
    }
  };

  const handleChangeMultiStopN = () => {
    setIsMultiStop(false);
    setChecked1(false);
  };

  const selectDoorType = (e) => {
    const { id, value } = e.currentTarget;
    if (selectedTrailerDoorValue === id) {
      setSelectedTrailerDoorValue('');
      setTrailerDoorType('');
      setSelectedLoadValue('Unload');
      setIsLiveLoad(false);
      return;
    }
    setTrailerDoorType(value);
    setSelectedLoadValue('Load');
    setIsLiveLoad(true);
    if (id === 'Swingdoor') {
      setSelectedTrailerDoorValue(id);
    } else if (id === 'RollUpdoor') {
      setSelectedTrailerDoorValue(id);
    } else if (id === 'Slidingdoor') {
      setSelectedTrailerDoorValue(id);
    } else if (id === 'Foldingdoor') {
      setSelectedTrailerDoorValue(id);
    } else if (id === 'Hingeddoor') {
      setSelectedTrailerDoorValue(id);
    }
  };
  const selectLiveLoad = (e) => {
    if (e.currentTarget.value === 'Yes') {
      setIsLiveLoad(true);
      setSelectedLoadValue('Load');
    } else if (e.currentTarget.value === 'No') {
      setIsLiveLoad(false);
      setSelectedLoadValue('UnLoad');
      setLiveLoadHours(0);
      formAddTrailerRequest.setFieldValue('LiveLoadHours', '');
    }
  };

  const selectSpecialInstruction = (e) => {
    setSpecialInstruction(e.currentTarget.value);
  };
  const validateSpecialInstruction = () => {
    const needsInstruction = deliveryproductType === 5 && selectedValue === 'Loaded';
    if (needsInstruction && !specialInstruction) {
      setNewErrorAlert(true);
      setErrorMessage('Special instruction is required for mixed loaded goods.');
      return false;
    }
    return true;
  };

  const validateLoaded = () => {
    if (
      (selectedTrailerPickValue !== '' &&
        selectedTrailerPickValue !== 'None' &&
        selectedTrailerPickValue !== undefined) ||
      (selectedValue !== '' && selectedValue !== 'None' && selectedValue !== undefined)
    ) {
      return true;
    }

    if (!selectedTrailerPickValue && !selectedValue) {
      setNewErrorAlert(true);
      setErrorMessage('Please choose Pickup-Delivery option');
      return false;
    }

    if (specialInstruction !== '' && specialInstruction !== undefined) {
      return true;
    }

    setNewErrorAlert(true);
    setErrorMessage('Please provide instruction.');
    return false;
  };

  const validateTrailer = () => {
    if (userType === 'Store') {
      if (selectedTrailerPickValue === 'Empty' || selectedTrailerPickValue === 'Loaded') {
        if (trailerID !== 0) {
          return true;
        }

        setNewErrorAlert(true);
        setErrorMessage('Please select Trailer');
        return false;
      }
      return true;
    }
    if (userType === 'Supplier') {
      if (selectedTrailerPickValue === 'Loaded') {
        if (!trailerID) {
          setNewErrorAlert(true);
          setErrorMessage('Please select Trailer');
          return false;
        }
      } else {
        return true;
      }
    }

    return true;
  };

  const validateCommodity = () => {
    if (selectedTrailerPickValue !== 'Loaded') {
      return true;
    }

    if (selectedTrailerPickValue === 'Loaded') {
      if (productType !== '' && productType !== undefined) {
        return true;
      }

      setNewErrorAlert(true);
      setErrorMessage('Select commodity');
      return false;
    }
  };

  const validateDeliverydate = (deliveryDate) => {
    if (selectedValue === 'Loaded' || selectedValue === 'Empty') {
      const minDate = startOfDay(addDays(getLocalDateTime(), 3));
      const selectedDate = startOfDay(parse(deliveryDate, 'yyyy-MM-dd', getLocalDateTime()));

      if (isValid(selectedDate) && (isAfter(selectedDate, minDate) || isEqual(selectedDate, minDate))) {
        return true;
      }
      setWarningModal(true);
      setWarning(
        'The requested date is not within 72 hours.  The traffic team will make every effort to meet your requested timeline',
      );
      return true;
    }
  };

  const validatePickupDate = (pickupDate) => {
    if (selectedTrailerPickValue === 'Loaded' || selectedTrailerPickValue === 'Empty') {
      const minDate = startOfDay(addDays(getLocalDateTime(), 3));
      const selectedDate = startOfDay(parse(pickupDate, 'yyyy-MM-dd', getLocalDateTime()));

      if (isValid(selectedDate) && (isAfter(selectedDate, minDate) || isEqual(selectedDate, minDate))) {
        return true;
      }
      setWarningModal(true);
      setWarning(
        'The requested pickup date is not within 72 hours. The traffic team will make every effort to meet your requested timeline',
      );
      return true;
    }
  };

  const validatePickupTimeframe = () => {
    if (selectedTrailerPickValue === 'Loaded' || selectedTrailerPickValue === 'Empty') {
      if (trailerRequestTimeframe) {
        return true;
      }
      setAlertOpen(true);
      setAlertMessage('Please select pickup timeframe');
      return false;
    }
    return true;
  };

  const validateDeliveryTimeRange = () => {
    if (selectedValue === 'Loaded' || selectedValue === 'Empty') {
      if (deliveryTime) {
        return true;
      }
      setNewErrorAlert(true);
      setErrorMessage('Please select delivery time between 8 AM and 4 PM');
      return false;
    }
    return true;
  };

  const requiredPickUpdate = () => {
    if (!trailerRequestDate && selectedTrailerPickValue !== 'None') {
      setNewErrorAlert(true);
      setErrorMessage('Pickup date required');
      return false;
    }

    const pickupDateStr =
      typeof trailerRequestDate === 'string'
        ? trailerRequestDate.substring(0, 10)
        : format(new Date(trailerRequestDate), 'yyyy-MM-dd');
    const deliveryDateStr =
      typeof deliveryDate === 'string'
        ? deliveryDate
        : deliveryDate
          ? format(new Date(deliveryDate), 'yyyy-MM-dd')
          : '';

    if (
      (selectedTrailerPickValue === 'Loaded' || selectedTrailerPickValue === 'Empty') &&
      (selectedValue === 'Loaded' || selectedValue === 'Empty') &&
      pickupDateStr &&
      deliveryDateStr
    ) {
      const pickupDay = startOfDay(parse(pickupDateStr, 'yyyy-MM-dd', getLocalDateTime()));
      const deliveryDay = startOfDay(parse(deliveryDateStr, 'yyyy-MM-dd', getLocalDateTime()));

      if (isAfter(pickupDay, deliveryDay)) {
        setNewErrorAlert(true);
        setErrorMessage('Pickup date needs to be the same as or earlier than the delivery date');
        return false;
      }
    }

    return true;
  };

  const validateStop = () => {
    if (isMultiStop === false) {
      return true;
    }
    if (stop1 !== 0 && stop1 !== '0') {
      return true;
    }
    setNewErrorAlert(true);
    setErrorMessage('Select stop1 location');
    return false;
  };

  const validateDelCommodity = () => {
    if (selectedValue !== 'Loaded') {
      return true;
    }

    if (selectedValue === 'Loaded') {
      if (deliveryproductType !== '' && deliveryproductType !== undefined) {
        return true;
      }

      setNewErrorAlert(true);
      setErrorMessage('Select delivery commodity');
      return false;
    }
  };

  const disabledTime = () => {
    return {
      disabledHours: () => {
        const hours = [];

        for (let i = 0; i < 24; i++) {
          if (i < 8 || i > 15) {
            hours.push(i);
          }
        }
        return hours;
      },
      disabledMinutes: () => {
        return [];
      },
      disabledSeconds: () => {
        return [];
      },
    };
  };

  useEffect(() => {
    const trailerSize = formAddTrailerRequest.getFieldValue('trailerSize') || 0;
    const trailerValue = trailerSize && trailerSizeOptions?.filter((val) => val.value === trailerSize)[0]?.label;
    const newPercentage =
      trailerValue > 0 && estimatedDimension >= 0 ? Math.min((estimatedDimension / trailerValue) * 100, 100) : 0;
    setPercentage(newPercentage);
  }, [trailerSizeOptions, estimatedDimension, formAddTrailerRequest]);

  const getProgressBarColor = (percentage) => {
    if (percentage <= 90) {
      return 'red';
    }
    if (percentage <= 95) {
      return 'yellow';
    }
    return 'green';
  };

  const progressBarColor = getProgressBarColor(percentage);

  const handleNewLocation = () => {
    setAddressBookModal(true);
  };

  const onSelectAddressBook = () => {
    //Todo add the states and update the data accordingly based on address changes
    setAddressBookModal(false);
  };

  const handleAddressBookModalClose = () => {
    setAddressBookModal(false);
  };

  const handleMatchesDDPChange = (e) => {
    setMatchesDDP(e);
  };

  const handleExpDeliveryDateChange = (e) => {
    const expectedDeliveryDate = format(new Date(e), 'yyyy-MM-dd');
    setExpDeliveryDate(expectedDeliveryDate);
  };

  const handleExpDeliveryTimeChange = (e) => {
    setExpDeliveryTime(e.value);
  };

  const handleCommentsChange = (e) => {
    setComments(e.target.value);
  };
  const toggleModal = () => {
    setShowProductsModal(!showProductsModal);
  };

  const commonProps = {
    addressLabel,
    alertMessage,
    alertOpen,
    branchAddr1,
    branchAddr2,
    branchBusPhone,
    branchCity,
    branchContact,
    branchCustRef,
    branchDesc,
    branchKey,
    branchPostal,
    branchState,
    checked1,
    closeModal,
    comments,
    commodityOptions,
    deliveryDate,
    deliveryproductTypeName,
    deliveryTime,
    deliveryTimeOptions,
    disabledTime,
    districtManager,
    errorMessage,
    estimatedDimension,
    estimatedWeight,
    expDeliveryDate,
    expDeliveryTime,
    formAddTrailerRequest,
    fullName,
    getTrailerList,
    handleAlertClose,
    handleAlertOk,
    handleChangeMultiStopN,
    handleChangeMultiStopY,
    handleCommentsChange,
    handleExpDeliveryDateChange,
    handleExpDeliveryTimeChange,
    handleMatchesDDPChange,
    hidden,
    isEmptyDelivered,
    isEmptyPickUp,
    isLiveLoad,
    isLoadedDelivered,
    isLoadedPickUp,
    liveLoadHours,
    liveLoadHoursOptions,
    loadTrailer,
    locationID,
    locationLabel,
    matchesDDP,
    nameLabel,
    newErrorAlert,
    onConfirmFunc,
    openRequestPopup,
    partnerLocationOptions,
    percentage,
    phoneLabel,
    pickupDateLabel,
    pickupTimeLabel,
    productType,
    productTypeName,
    progressBarColor,
    requester,
    requestTypeOptions,
    rscm,
    saveTrailerRequestData,
    scs,
    selectCommodity,
    selectDelivered,
    selectDeliveryDate,
    selectDeliveryTime,
    selectDoorType,
    selectdeliveryCommodity,
    selectedLoadValue,
    selectedTrailerDoorValue,
    selectedTrailerPickValue,
    selectedValue,
    selectLiveLoad,
    selectLocationID,
    selectProduct,
    selectRequestDate,
    selectRequestTime,
    selectRequestTimeframe,
    selectSealNumber,
    selectSpecialInstruction,
    selectStop1,
    selectStop2,
    selectStop3,
    selectTrailerConditionStatus,
    selectTrailerName,
    selectTrailerSize,
    setFullName,
    setHidden,
    setLiveLoadUnloadHour,
    setPercentage,
    setRequesterName,
    setSupplierPhone,
    setTableData,
    setWarningModal,
    shouldToggleChecked,
    showModal: showProductsModal,
    stop1,
    stop2,
    stop3,
    tableData,
    toggleModal,
    trailerConditionStatusID,
    trailerConditionStatusOptions,
    trailerName,
    trailerOptions,
    trailerRequestDate,
    trailerRequestTimeframe,
    trailerSizeOptions,
    trlHidden,
    userType,
    warning,
    warningModal,
  };

  if (!userType) {
    return null;
  }

  if (userType === 'Store') {
    return <StoreTrailerRequest {...commonProps} />;
  }

  if (userType === 'Supplier') {
    return (
      <SupplierTrailerRequest
        {...commonProps}
        handleNewLocation={handleNewLocation}
        addressBookModal={addressBookModal}
        onSelectAddressBook={onSelectAddressBook}
        handleAddressBookModalClose={handleAddressBookModalClose}
      />
    );
  }

  return <CtTrailerRequest {...commonProps} />;
}
